import { cx } from '@trm/ui-kit-admin/v7/utils';
import logoT from '~/assets/images/auth/topstep_t.svg';
import logoWithTagline from '~/assets/images/topstep+tagline.svg';

interface Props {
  isOpen: boolean;
}

export const DrawerHeader = ({ isOpen }: Props) => {
  return (
    <a
      href="https://www.topstep.com"
      target="_blank"
      rel="noreferrer"
      aria-label="Topstep homepage (opens in a new tab)"
      className={cx('flex flex-col items-center justify-center', isOpen ? 'pt-6' : 'pt-3 pb-2.5')}
    >
      <img
        src={isOpen ? logoWithTagline : logoT}
        alt={'Topstep — The Ultimate Trading Experience'}
        className={cx(
          'w-auto object-contain invert dark:invert-0',
          isOpen ? 'h-[48px]' : 'h-[35px]',
        )}
      />
    </a>
  );
};
